import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Client } from '../../client.types';

@Component({
    selector: 'client-listing-table',
    templateUrl: './listing-table.component.html',
    styleUrls: ['./listing-table.component.scss'],
})
export class ClientListingTableComponent {
    @Input() clients: Client[];
    @Input() pinnedClientIds: number[] = [];
    @Input() hideMenu = false;
    @Input() canPin: boolean = true;
    @Output() pin: EventEmitter<Client> = new EventEmitter<Client>();
    @Output() unpin: EventEmitter<Client> = new EventEmitter<Client>();
    @Output() selectClient: EventEmitter<number> = new EventEmitter<number>();
    @Output() selectGroup: EventEmitter<number> = new EventEmitter<number>();
    groupsExpanded = {};

    onSelectClient(clientId: number) {
        this.selectClient.emit(clientId);
    }

    onSelectGroup(clientId: number) {
        this.selectGroup.emit(clientId);
    }

    onGroupToggle(groupId: number) {
        this.groupsExpanded[groupId]
            ? delete this.groupsExpanded[groupId]
            : (this.groupsExpanded[groupId] = true);
    }

    onPin(client: Client) {
        this.pin.emit(client);
    }

    onUnPin(client: Client) {
        this.unpin.emit(client);
    }

    onPinGroup(client: Client) {
        this.pin.emit({ ...client, children: this.groupClientsOf(client) });
    }

    onUnPinGroup(client: Client) {
        this.unpin.emit({ ...client, children: this.groupClientsOf(client) });
    }

    isClientPinned(clientId: number): boolean {
        return this.pinnedClientIds.includes(clientId);
    }

    isGroupPinned(groupName: string): boolean {
        if (!groupName) return false;
        return this.clients
            .filter(c => c.groupName === groupName)
            .some(c => this.pinnedClientIds.includes(c.clientId));
    }

    private groupClientsOf(client: Client): Client[] {
        return this.clients.filter(c => c.groupName === client.groupName);
    }
}
